import { Component, OnInit } from '@angular/core';
import { EnvironmentService } from 'src/app/services/environment.service';
import { FacilityConfig } from 'src/environments/environment.interface';

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss']
})
export class AppLayoutComponent implements OnInit {
  settings: FacilityConfig;
  constructor(
    private _environmentService: EnvironmentService
  ) { }

  ngOnInit() {
    this.settings = this._environmentService.getFacilityConfig();
  }

  showHeader(): boolean {
    return this.settings.style.header.show;
  }
}
